// The origin that served this bundle. Captured at module scope: document.currentScript
// is only set while the script is evaluating, not later when Link is opened.
const servingOrigin = ((): string | undefined => {
  if (typeof document === "undefined") {
    return undefined;
  }
  const src = (document.currentScript as HTMLScriptElement | null)?.src;
  if (!src) {
    return undefined;
  }
  try {
    return new URL(src, window.location.href).origin;
  } catch {
    return undefined;
  }
})();

/**
 * Origin to load Link's own assets (the flow iframe, the telemetry plugin) from.
 *
 * Single tenants are served from their own CDN host so the widget can set a cookie
 * their API reads back. Resolving this from the environment the bundle was built for
 * sent those tenants to merge.dev, which is a different registrable domain, so the
 * cookie never reached them. The origin that served the bundle is the tenant's own.
 */
export const getCdnOrigin = (): string => {
  if (process.env.REACT_APP_USE_LOCAL_CDN) {
    return "http://localhost:3005";
  }
  if (servingOrigin) {
    return servingOrigin;
  }
  switch (process.env.REACT_APP_MERGE_ENV) {
    case "PRODUCTION":
      return "https://ah-cdn.merge.dev";
    case "DEVELOP":
      return "https://ah-cdn-develop.merge.dev";
    case "LOCAL":
    default:
      return "http://localhost:3005";
  }
};
